import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DimensionPickerComponent } from './dimension-picker.component';

@NgModule({
  declarations: [DimensionPickerComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule
  ],
  exports: [
    DimensionPickerComponent
  ]
})
export class DimensionPickerModule { }
